// extracted by mini-css-extract-plugin
export default {"root":"VBlrtY_qiV8lhF_ALn4B","label":"dMAZhm4IxolcbD_f1s2W","dropdown":"sorvP6yjVXm48Zajgi2s"};